module.exports = __webpack_public_path__ + "static/mr-press-28-1b4e12a6822d055328612cd086a5bc6f.jpg";